import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";

import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();


class Rep_tracking_master extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            allovehsl: false,
        }
    }

    async componentDidMount() {
        this.rep_tracking_master();
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    btnexport = (event) => {
        event.preventDefault();
        let wb=XLSX.utils.book_new();
        wb.SheetNames.push("Master Tracking");
        let wb2= XLSX.utils.table_to_sheet(document.getElementById('report_1'));
        wb.Sheets["Master Tracking"]=wb2;
        XLSX.writeFile(wb,"Master Trip Data.xlsx");
    }
    rep_tracking_master = () => {
        let baseurl = myconfig.rep_tracking_master;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            allovehsl: false,
            cushow: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    allovehs: res.data,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.allovehs.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>{value.plate_no}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.frightno}</td>
                    <td>{value.cargo_id}</td>
                    <td>{value.customer_id}</td>
                    <td>{value.rr_rou}</td>
                    <td>{value.rr_distance}</td>
                    <td>{value.avl_loc}</td>
                    <td>{value.avl_time}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }


    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="rep_tracking_master"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Daily Master Tracking</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Master Tracking</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm">
                                                <a href="" onClick={this.btnexport}>Download .xlsx</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table id="report_1" className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>SL. NO</th>
                                                <th>TRUCK #</th>
                                                <th>TRAILER #</th>
                                                <th>DRIVER NAME</th>
                                                <th>CONTACT</th>
                                                <th>FREIGHT ORDER #</th>
                                                <th>CARGO TYPE</th>
                                                <th>CLIENT</th>
                                                <th>ROUTE</th>
                                                <th>DISTANCE</th>
                                                <th>CURRENT LOCATION</th>
                                                <th>GPS TIME</th>
                                                <th>Status</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Rep_tracking_master;
